"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _VignetteModule = _interopRequireDefault(require("./Vignette.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Vignette = function Vignette(_ref) {
  var className = _ref.className,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === void 0 ? 2 : _ref$strokeWidth,
      _ref$segments = _ref.segments,
      segments = _ref$segments === void 0 ? 2 : _ref$segments,
      _ref$curvature = _ref.curvature,
      curvature = _ref$curvature === void 0 ? 1 : _ref$curvature,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 0 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 12 : _ref$width,
      _ref$strokeDasharray = _ref.strokeDasharray,
      strokeDasharray = _ref$strokeDasharray === void 0 ? '1' : _ref$strokeDasharray;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: (0, _clsx["default"])(_VignetteModule["default"].vignette, className),
    height: "100%",
    width: "100%",
    style: {
      maxWidth: segments * 2 * width
    }
  }, /*#__PURE__*/_react["default"].createElement("pattern", {
    id: "pattern-vignette",
    x: "0",
    y: "0",
    width: width * 2,
    height: height * 2 + strokeWidth,
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 ".concat(width * 2, " ").concat(height * 2 + strokeWidth)
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: className,
    d: "M0,".concat(height + strokeWidth * 0.5, " c").concat(width - width * curvature, ",0,").concat(width * curvature, ",-").concat(height, ",").concat(width, ",-").concat(height, " s").concat(width * curvature, ",").concat(height, ",").concat(width, ",").concat(height),
    strokeWidth: strokeWidth,
    strokeDasharray: strokeDasharray
  })), /*#__PURE__*/_react["default"].createElement("rect", {
    stroke: "none",
    x: "0",
    y: "0",
    width: "100%",
    height: height * 2 + strokeWidth,
    fill: "url(#pattern-vignette)"
  }));
};

Vignette.defaultProps = {
  name: 'none'
};
Vignette.displayName = 'Vignette';
var _default = Vignette;
exports["default"] = _default;